import React, { useState } from "react";

interface AccordionProps {
  title: string;
  content: React.ReactNode;
  defaultOpen?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({ title, content, defaultOpen = false }) => {
  const [open, setOpen] = useState<boolean>(defaultOpen);

  const toggleAccordion = () => {
    setOpen((prev) => !prev);
  };

  return (
    <div className="w-full">
      <div className="border-b border-gray-200">
        <button
          className="w-full flex justify-between items-center py-3 text-left text-gray-700 font-semibold focus:outline-none"
          onClick={toggleAccordion}
          aria-expanded={open}
        >
          {title}
          <span
            className={`transform transition-transform duration-200 ${
              open ? "rotate-180" : "rotate-0"
            }`}
          >
            ▼
          </span>
        </button>
        <div
          className={`transition-all duration-300 ${
            open ? "max-h-[fit-content] opacity-100 py-3" : "max-h-0 opacity-0"
          } overflow-hidden`}
        >
          <div className="px-4">{content}</div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;